import React from 'react'
import {
  Input,
  BaseForm,
  Radio,
  SingleDatePicker,
} from '../../../../components/Form'
import { getMessage } from '../../../../lib/translator'

class ScanCampaignFilter extends BaseForm {
  render() {
    const { Form } = this.components
    const { SubmitButton, ClearButton } = this.buttons

    return (
      <Form className="offer-filters">
        <div className="form-fields">
          <Input
            name="id"
            label={getMessage('offer.scanCampaigns.filter.id')}
            placeholder={getMessage(
              'offer.scanCampaigns.filter.id.placeholder'
            )}
            type="text"
            onKeyDown={(e) => {
              const allowedKeys = [
                'Backspace',
                'Delete',
                'ArrowLeft',
                'ArrowRight',
                'Tab',
                'Control',
                'Meta',
                'Enter',
                'Shift', // for combo keys
              ]

              const isCtrlCombo =
                (e.ctrlKey || e.metaKey) &&
                ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())

              const isAllowed = allowedKeys.includes(e.key) || isCtrlCombo

              if (!isAllowed && !/^\d$/.test(e.key)) {
                e.preventDefault()
              }
            }}
            {...this.generateStateMappers({
              stateKeys: ['id'],
              loseEmphasisOnFill: true,
              formatChange: (value) => value.replaceAll(/\D/g, ''),
            })}
          />

          <Input
            name="nameMatch"
            placeholder={getMessage(
              'offer.scanCampaigns.filter.name.placeholder'
            )}
            label={getMessage('offer.scanCampaigns.filter.name')}
            type="text"
            {...this.generateStateMappers({
              stateKeys: ['nameMatch'],
              loseEmphasisOnFill: true,
            })}
          />

          <SingleDatePicker
            allowAllDates
            label={getMessage('offer.scanCampaigns.filter.startDate')}
            {...this.generateStateMappers({
              stateKeys: ['startDate'],
              loseEmphasisOnFill: true,
            })}
          />

          <SingleDatePicker
            allowAllDates
            label={getMessage('offer.scanCampaigns.filter.endDate')}
            {...this.generateStateMappers({
              stateKeys: ['endDate'],
              loseEmphasisOnFill: true,
            })}
          />

          <Radio
            label={getMessage('offer.status')}
            options={[
              {
                text: getMessage('offer.all'),
                value: '',
              },
              {
                text: getMessage('offer.enabled'),
                value: 'ENABLED',
              },
              {
                text: getMessage('offer.disabled'),
                value: 'DISABLED',
              },
            ]}
            name="status"
            {...this.generateStateMappers({
              stateKeys: ['status'],
              loseEmphasisOnFill: true,
            })}
          />
        </div>
        <SubmitButton>{getMessage('offer.submit')}</SubmitButton>
        <ClearButton>{getMessage('offer.clear')}</ClearButton>
      </Form>
    )
  }
}

export default ScanCampaignFilter
